import { get } from 'lodash';

export const selectConditionStatistics = (state) => get(state, 'statistics.conditionStatistics');

export const selectStateStatistics = (state) => get(state, 'statistics.stateStatistics');

export const selectConnectionStatistics = (state) => get(state, 'statistics.connectionStatistics');

export const selectFaultsStatistics = (state) => get(state, 'statistics.faultsStatistics');

export const selectAggregatedStatistics = (state) => get(state, 'statistics.aggregatedStatistics');

export const selectTotalEnergyStatistics = (state) => get(state, 'statistics.totalEnergyStatistics', {});
